import { h, render } from 'preact';
import { initFrame, sendFrameHeight, initFrameAndPoll } from '@newswire/frames';
import CountyLookup from '../components/CountyLookup';

render(<CountyLookup />, document.getElementById("county-lookup"));
initFrameAndPoll(200);

if (process.env.NODE_ENV === 'development') {
  require('preact/debug');
}
